<template>
  <div
    :class="['q-px-sm q-py-xs', fieldWidth, 'vonix-phone-fields column']"
    :style="{ minWidth: minWidthPx }"
  >
    <label class="col-auto column">
      <div :class="['label col-auto', isRequired ? 'required-class' : '' , hasError ? 'has-error' : '', bold ? 'text-bold': '']">
        {{ labelInfo }}
      </div>

      <template v-if="!$scopedSlots['after']">
        <div class="col">
          <slot />
        </div>

        <CollapseTransition>
          <q-banner
            dense
            rounded
            v-if="errorMessage"
            class="col-auto bg-white text-red-9 q-pa-none"
          >
            <small><b>{{ errorMessage }}</b></small>
          </q-banner>
        </CollapseTransition>
      </template>
    </label>

    <template v-if="$scopedSlots['after']">
      <div class="col">
        <slot name="after" />
      </div>

      <CollapseTransition>
        <q-banner
          dense
          rounded
          v-if="errorMessage"
          class="col-auto bg-white text-red-9 q-pa-none"
        >
          <small><b>{{ errorMessage }}</b></small>
        </q-banner>
      </CollapseTransition>
    </template>
  </div>
</template>

<script>
import { CollapseTransition } from '@ivanv/vue-collapse-transition'

export default {
  components: {
    CollapseTransition
  },

  props: {
    bold: { type: Boolean, default: false },
    label: {},
    state: {},
    configs: {}
  },

  computed: {
    errorMessage () {
      return this.state?.dirty ? this.state?.error : ''
    },

    hasError () {
      return Boolean(this.errorMessage)
    },

    isRequired () {
      return ['yes', 'y', 't', 'true', true].includes(this.configs?.fieldRequired)
    },

    fieldWidth () {
      return this.configs?.fieldWidth ?? 'col-6'
    },

    minWidthPx () {
      return null
    },

    labelInfo () {
      return this.isRequired ? `${this.label}*` : this.label
    }
  }
}
</script>

<style lang="sass">
.vonix-phone-classes
  .q-field--with-bottom
    padding-bottom: 0

  .vonix-phone-fields

    .has-error
      color: #C00F0C !important

    .label
      position: relative
      font-style: normal
      font-weight: 500
      font-size: 12px
      line-height: 16px
      color: #52707F
      padding-right: 10px
      padding-bottom: 2px

      .required-class
        position: absolute
        top: 3px
        right: 0

    .q-field__control
      height: 32px
      min-height: 32px
      padding: 0 4px 0 8px
      border-radius: 6px

      .q-field__control-container
        font-style: normal
        font-weight: normal
        font-size: 13px
        line-height: 18px
        color: rgba(1, 37, 60, 0.9)

      &:before
        border-color: #CDDCE5

      &:hover
        &:before
          border: 1px solid #1769B6
          transition: none

      &:after
        border-width: 1px !important

    .q-field__control-container
      .q-field__native
        min-height: 0px !important
        padding-bottom: 5px

      .q-field__prefix
        line-height: inherit !important
        margin-bottom: 1px
        padding: 1px 1px 0 0

    .q-field__marginal
      height: 32px
      padding-bottom: 0px

    .vue-treeselect__control
      height: 34px
      border-radius: 6px
      border-color: #CDDCE5

    .vue-treeselect--single.vue-treeselect--disabled
      .vue-treeselect__control
        border: 1px dashed rgba(0, 0, 0, 0.24)
        background-color: white

    .vue-treeselect--multi.vue-treeselect--disabled
      .vue-treeselect__control
        border: 1px dashed rgba(0, 0, 0, 0.24)
        background-color: transparent

    .vue-treeselect--disabled
      .vue-treeselect__control-arrow-container
        display: none

    .vue-treeselect__placeholder, .vue-treeselect__single-value
      line-height: 32px

    .disabled, [disabled]
      opacity: 1 !important
      cursor: text !important

    .mx-datepicker
      width: 100% !important

      input.mx-input
        height: 32px
        border-radius: 6px
        border-color: #CDDCE5

      input.mx-input:disabled
        color: rgba(0, 0, 0, 0.87)
        border: 1px dashed rgba(0, 0, 0, 0.24) !important
        background-color: white

</style>
